module.exports = __webpack_public_path__ + "img/202307191537195511ks.07728921.jpg";